import {
  createSlice,
  createAsyncThunk,
  createSelector,
  createEntityAdapter
} from '@reduxjs/toolkit';
import sub from 'date-fns/sub';
import axios from 'axios';

const FEATURE_URL = 'http://localhost:3300/homes';
//const MAIN_FEATURE_URL = 'http://localhost:3300/homes/main';  //used only for main page

const FeatureName = 'homes';
export const FeatureForCamelCase = 'Homes';
export const FeatureForCamelCaseCRUD = 'Home';

const mainFeatureName = "mains";
const MainFeatureForCamelCase = "Mains";
const MainFeatureForCamelCaseCRUD = "Mains";

 const adapters = {
  [`${FeatureName}Adapter`]: createEntityAdapter({
    sortComparer: (a, b) => b.date.localeCompare(a.date),
    selectId: (entity) => {
      if (typeof entity === 'string') {
        // Handle string entities
        return entity;
      }
      // Handle object entities
      return entity.id;
    }
  })  
  
}; 
/*
    ADDING ROUTE TO MAIN 

*/

//DONT KNOW IF IT IS WORTH
const mainHomesAdapter = createEntityAdapter({
  sortComparer: (a, b) => b.date.localeCompare(a.date),
  selectId: (entity) => {
    if (typeof entity === 'string') {
      // Handle string entities
      return entity;
    }
    // Handle object entities
    return entity.id;
  }
})

export const fetchers = {
  [`fetch${FeatureForCamelCase}`]: createAsyncThunk(
    `${FeatureName}/fetch${FeatureForCamelCase}`,
    async () => {
      try {
        const response = await axios.get(FEATURE_URL);
        console.log(response);
        return response.data.map(item => ({
          ...item,
          /* reactions: {
            thumbsUp: 0,
            heart: 0
          } */
        }));
      } catch (err) {
        return err.message;
      }
    }
  ),
  
};

export const fetchMainHomes = createAsyncThunk('homes/fetchMainHomes', async () => {
  try {
    const response = await axios.get('/homes/main');
    console.log(response);
    return response.data.map(item => ({
      ...item,
      /* reactions: {
        thumbsUp: 0,
        heart: 0
      } */
    }));
  } catch (err) {
    return err.message;
  }
});

export const adders = {
  [`addNew${FeatureForCamelCaseCRUD}`]: createAsyncThunk(
    `${FeatureName}/addNew${FeatureForCamelCaseCRUD}`,
    async (newData) => {
      try {
        const response = await axios.post(FEATURE_URL, newData);
        return response.data;
      } catch (err) {
        return err.message;
      }
    }
  )
};

export const updaters = {
  [`update${FeatureForCamelCaseCRUD}`]: createAsyncThunk(
    `${FeatureName}/update${FeatureForCamelCaseCRUD}`,
    async (updatedData) => {
      const { id } = updatedData;
      try {
        const response = await axios.put(`${FEATURE_URL}/${id}`, updatedData);
        return response.data;
      } catch (err) {
        return err.message;
      }
    }
  )
};

export const deleters = {
  [`delete${FeatureForCamelCaseCRUD}`]: createAsyncThunk(
    `${FeatureName}/delete${FeatureForCamelCaseCRUD}`,
    async (id) => {
      try {
        const response = await axios.delete(`${FEATURE_URL}/${id}`);
        if (response?.status === 200) return id;
        return `${response?.status} : ${response?.statusText}`;
      } catch (err) {
        return err.message;
      }
    }
  )
};

const slicesCreators = {
  [`${FeatureName}Slice`]: createSlice({
    name: `${FeatureName}`,
    initialState: adapters[`${FeatureName}Adapter`].getInitialState({
      status: 'idle',
      error: null
    }),
    /* reducers: { //Keep the feature name in here
      reactionAdded(state, action) {
        const { homeId, reaction } = action.payload;
        const existingHome = state.entities[homeId];
        if (existingHome) {
          existingHome.reactions[reaction]++;
        }
      },
    }, */
    extraReducers(builder) {
      builder
        .addCase(fetchers[`fetch${FeatureForCamelCase}`].pending, (state, action) => {
          state.status = 'loading';
        })
        .addCase(fetchers[`fetch${FeatureForCamelCase}`].fulfilled, (state, action) => {
          state.status = 'succeeded';
          // Adding date and reactions
          let min = 1;
          const loadedItems = Array.isArray(action.payload) ? action.payload.map(home => { //Needs to be home
            home.date = sub(new Date(), { minutes: min++ }).toISOString();
            /* home.reactions = {
              thumbsUp: 0,
              heart: 0
            }; */
            return home;
          }) : [];
          adapters[`${FeatureName}Adapter`].upsertMany(state, loadedItems);
        })
        .addCase(fetchMainHomes.fulfilled, (state, action) => {
          state.status = 'succeeded';
          // Adding date and reactions
          let min = 1;
          const loadedItems = Array.isArray(action.payload) ? action.payload.map(mainHome => { //Needs to be home
            mainHome.date = sub(new Date(), { minutes: min++ }).toISOString();
            /* home.reactions = {
              thumbsUp: 0,
              heart: 0
            }; */
            return mainHome;
          }) : [];
          mainHomesAdapter.upsertMany(state, loadedItems);
        })




        
      .addCase(adders[`addNew${FeatureForCamelCaseCRUD}`].fulfilled, (state, action) => {
        if(typeof action.payload === 'string') {
          console.log(action.payload)
        }else if(typeof action.payload === 'object'){
          action.payload.userId = Number(action.payload.userId);
          action.payload.date = new Date(action.payload.date).toISOString();
          /* action.payload.reactions = {
            thumbsUp: 0,
            heart: 0
          }; */
        }
        adapters[`${FeatureName}Adapter`].addOne(state, action.payload);
      })
      .addCase(updaters[`update${FeatureForCamelCaseCRUD}`].fulfilled, (state, action) => {
        const updatedItem = action.payload;
        adapters[`${FeatureName}Adapter`].upsertOne(state, updatedItem);
      })
      .addCase(deleters[`delete${FeatureForCamelCaseCRUD}`].fulfilled, (state, action) => {
        const { id } = action.payload;
        adapters[`${FeatureName}Adapter`].removeOne(state, id);
      })



      /*
      adding the new route to main homes
      not working
      
      */

      //TO BE CHANGED AFTERWARDS


      /* .addCase(fetchMainHomes.fulfilled, (state, action) => {
        return action.payload.map(mainHome);
      }); */
    }
  })
}

export const {
  selectAll: selectAllItems,
  selectById: selectItemById,
  selectIds: selectItemIds,
} = adapters[`${FeatureName}Adapter`].getSelectors(state => state[`${FeatureName}`]); //State needs to be home

export const getItemsStatus = (state) => state[`${FeatureName}`].status;
export const getItemsError = (state) => state[`${FeatureName}`].error;

export const selectHomesByUser = createSelector(
  [selectAllItems, (state, userId) => userId],
  (homes, userId) => homes.filter((home) => home.userId === userId)
)

export const selectAllHomes = (state) => state.homes;
/*
  adding the new route to main homes
  not working

*/
//creating a selector
export const selectMainHomes = createSelector(
  [selectAllItems],
  (homes) => homes.filter((home) => home.main === true)
)

//export const { reactionAdded } = slicesCreators[`${FeatureName}Slice`].actions

export default slicesCreators[`${FeatureName}Slice`].reducer;